<template>
<!-- Site wrapper -->
<div>
  <!-- Main content -->
  <section class="content">
    <!-- Default box -->
    <div class="row">
      <div class="col-md-12 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <div v-if="flagsDeControle.carregandoDados.status" class="d-flex align-items-center">
              <span class="avisoDanger">{{flagsDeControle.carregandoDados.mensagem}}</span>
              <b-spinner class="ml-2" variant="danger"></b-spinner>
            </div>
            <form class="forms-sample">
              <div class="form-row">
                <div class="form-group col-md-12 col-lg-12 col-xl-6">
                  <ul class="list-unstyled">
                    <li v-if="relatoriosContratado">
                      <div class="custom-control custom-switch custom-switch-off-danger custom-switch-on-success mb-2">
                        <input type="checkbox" v-model="formulario.f_reports" class="custom-control-input" id="customSwitchRelatorios" :disabled="flagsDeControle.manipulandoDados.status || flagsDeControle.carregandoDados.status">
                        <label class="custom-control-label" for="customSwitchRelatorios">Relatórios</label>
                      </div>
                    </li>
                    <li v-if="faturamentoContratado">
                      <div class="custom-control custom-switch custom-switch-off-danger custom-switch-on-success mb-2">
                        <input type="checkbox" v-model="formulario.f_billing" class="custom-control-input" id="customSwitchFaturamento" :disabled="flagsDeControle.manipulandoDados.status || flagsDeControle.carregandoDados.status">
                        <label class="custom-control-label" for="customSwitchFaturamento">Financeiro</label>
                      </div>
                    </li>
                    <li>
                      <div class="custom-control custom-switch custom-switch-off-danger custom-switch-on-success mb-2">
                        <input type="checkbox" v-model="formulario.f_financial" @click="verificarAcessoAoFinanceiro()" class="custom-control-input" id="customSwitchFinanceiro" :disabled="(flagsDeControle.manipulandoDados.status || flagsDeControle.carregandoDados.status)">
                        <label class="custom-control-label" for="customSwitchFinanceiro">Fluxo de Caixa</label>
                      </div>
                    </li>
                    <li>
                      <div class="custom-control custom-switch custom-switch-on-success">
                        <input type="checkbox" class="custom-control-input" disabled="" id="customSwitchOffice" checked>
                        <label class="custom-control-label" for="customSwitchOffice">Jurídico</label>
                      </div>
                      <ul style="list-style: none;">
                        <li v-for="(permissao, index) in listaMergeDasPermissoesDoUsuarioESistema" :key="`${permissao.f_name}-${index}`">
                          <div class="custom-control custom-switch custom-switch-off-danger custom-switch-on-success mb-2">
                            <input
                              type="checkbox"
                              v-model="permissao.habilitada"
                              class="custom-control-input"
                              :id="`customSwitch${permissao.f_name}-${index}`"
                              @change="habilitarAbaNegociadores(permissao)"
                              :disabled="flagsDeControle.manipulandoDados.status || flagsDeControle.carregandoDados.status">
                            <label class="custom-control-label" :for="`customSwitch${permissao.f_name}-${index}`">{{permissao.f_name}}</label>
                          </div>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </div>
              </div>
              <div v-if="flagsDeControle.manipulandoDados.status" class="d-flex align-items-center">
                <span class="avisoDanger">{{flagsDeControle.manipulandoDados.mensagem}}</span>
                <b-spinner class="ml-2" variant="danger"></b-spinner>
              </div>
            </form>
          </div> <!-- card-body ends -->
        </div> <!-- card ends -->
      </div>
    </div>
  </section> <!-- /.content -->
</div><!-- ./wrapper -->
</template>

<script>
import Permissoes from './js/permissoes'
export default Permissoes
</script>

<style scoped>
@import "./scss/usuarios.scss";
</style>
